require('./css/style.css')
import metadata from './lib/metadata'
import viewer from './lib/viewer'

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const culturalItemUuid = urlParams.get('culturalItemUuid')
const model3DUuid = urlParams.get('uuid')

function showStartupError(message, error) {
  console.error(message, error)

  const loaderOverlay = document.getElementById('loader-overlay')
  if (!loaderOverlay) return

  loaderOverlay.classList.remove('hidden')

  const spinner = loaderOverlay.querySelector('.spinner')
  if (spinner) {
    spinner.remove()
  }

  const paragraph = loaderOverlay.querySelector('p') || document.createElement('p')
  paragraph.textContent = message

  if (!paragraph.parentElement) {
    loaderOverlay.appendChild(paragraph)
  }
}

const GENERIC_STARTUP_ERROR_MESSAGE = 'Unable to load the 3D viewer.'

async function bootstrapViewer() {
  if (culturalItemUuid) {
    const model3DsData = await metadata.getModel3DsMetadataFromCulturalItem(culturalItemUuid)
    if (!model3DsData?.modelsLinks?.length) {
      throw new Error(`No 3D models found for cultural item ${culturalItemUuid}`)
    }
    await viewer.loadMultipleModels(model3DsData)
    return
  }

  if (model3DUuid) {
    const model3DsData = await metadata.getSingleModel3DMetadata(model3DUuid)
    if (!model3DsData?.modelsLinks?.length) {
      throw new Error(`No 3D model found for uuid ${model3DUuid}`)
    }
    await viewer.loadMultipleModels(model3DsData)
    return
  }

  throw new Error('Missing viewer identifier. Provide `culturalItemUuid` or `uuid` in the URL.')
}

if (culturalItemUuid) {
  bootstrapViewer().catch(error => {
    showStartupError(GENERIC_STARTUP_ERROR_MESSAGE, error)
  })
} else if (model3DUuid) {
  bootstrapViewer().catch(error => {
    showStartupError(GENERIC_STARTUP_ERROR_MESSAGE, error)
  })
} else {
  bootstrapViewer().catch(error => {
    showStartupError(GENERIC_STARTUP_ERROR_MESSAGE, error)
  })
}
